module.exports = __webpack_public_path__ + "static/media/juegos-de-juntas.95765410.jpg";